<template>
  <div class="">
    <a class="button is-link is-outlined is-fullwidth" @click="openModal"
      >Lägg till instruktör</a
    >
    <div class="modal" :class="{ 'is-active': open }">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Ny Instruktör</p>
          <button
            class="delete"
            aria-label="close"
            @click="closeModal"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">Förnamn</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Förnamn"
                v-model="instructor.first_name"
              />
            </div>
          </div>

          <div class="field">
            <label class="label">Efternamn</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Efternamn"
                v-model="instructor.last_name"
              />
            </div>
          </div>

          <div class="field">
            <label class="label">Mailadress</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Mailadress"
                v-model="instructor.email"
              />
            </div>
          </div>

          <div class="field">
            <label class="label">Telefonnummer</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Telefonnummer"
                v-model="instructor.phone_number"
              />
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-danger" @click="closeModal">Avbryt</button>
          <button
            class="button is-success add"
            @click="addInstructor"
            :disabled="valid()"
          >
            Skapa instruktör
          </button>
        </footer>
      </div>
      <button class="modal-close is-large" aria-label="close"></button>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request.js";

export default {
  name: "NewInstructor",
  data: function () {
    return {
      open: false,
      instructor: {},
      valid: function () {
        return !(
          !!this.instructor.first_name &&
          !!this.instructor.last_name &&
          !!this.instructor.email &&
          !!this.instructor.phone_number
        );
      },
    };
  },
  methods: {
    openModal() {
      this.open = true;
    },
    closeModal() {
      this.open = false;
    },
    addInstructor() {
      axios
        .post("/api/instructors/", this.instructor)
        .then(() => {
          this.$emit("reloadInstructors");
          this.closeModal();
        })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add {
  margin-left: auto;
}
</style>